import {
    i18_EDITPROJEKT,
    i18_EDITTERMIN,
    i18_EINNAHMEN,
    i18_FINALIZER,
    i18_KUNDE,
    i18_LIST,
    i18_MESSAGE,
    i18_TRANSLATION,
} from "../../i18nReferences";

/**
 * First entry is react-i18next defaultNS for useTranslation(ns).
 * Many kunde labels call t("EDIT_KUNDE.*") without an explicit ns option.
 */
export const KUNDE_I18N_NAMESPACES = [i18_KUNDE, i18_TRANSLATION];

/**
 * Full customer edit dialog (/kunde/:id) including tabs and EditProjektDialog.
 * KUNDE must stay first (defaultNS) for bare EDIT_KUNDE.* keys.
 */
export const KUNDE_EDIT_I18N_NAMESPACES = [
    i18_KUNDE,
    i18_TRANSLATION,
    i18_EDITPROJEKT,
    i18_EDITTERMIN,
    i18_EINNAHMEN,
    i18_MESSAGE,
    i18_LIST,
    i18_FINALIZER,
];
